import { atom } from 'jotai';
import type { ShareOptions } from '../utils/sharing';

/**
 * Overrides what the app-wide social sharing modal shares.
 *
 * The modal (mounted once via `SocialShareInitializer`) normally shares the
 * current page. A listing tile shares a specific item instead, so it sets this
 * atom before opening the modal; `SocialShareInitializer` shares this target
 * when present. Cleared automatically when the modal closes.
 */
export const shareTargetAtom = atom<ShareOptions | null>(null);
